import { Leaf } from "lucide-react";
import React from "react";
import { Card, CardContent } from "../../../components/ui/common/card";
import { COMPANY_NAME, ImpactAssessmentMethodText } from "../../../config/constants";

interface ClimateImpactCardProps {
  measure?: number;
  unit?: string;
}

/**
 * ClimateImpactCard Component
 * Single Responsibility: Display climate change impact metrics
 */
export const ClimateImpactCard: React.FC<ClimateImpactCardProps> = ({ measure, unit }) => {
  return (
    <Card className="tw-border-border tw-bg-gradient-to-br tw-pt-0 tw-mt-0 tw-s tw-from-card tw-to-secondary/30 tw-overflow-hidden">
      <CardContent className="tw-p-2 tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center tw-h-full">
        <div className="tw-w-full tw-border-b tw-border-primary/20 tw-pb-2.5 tw-mb-3.5">
          <p className="tw-text-sm tw-font-semibold tw-text-primary">Climate Change Impact</p>
        </div>
        <Leaf className="tw-h-7 tw-w-7 tw-text-primary/30 tw-mb-2" />
        <p className="tw-text-5xl tw-font-display tw-font-bold tw-text-foreground tw-leading-none">
          {measure?.toFixed(2) || "0.00"}
        </p>
        <p className="tw-text-sm tw-text-muted-foreground tw-mt-1.5 tw-font-medium">
          {unit || "kgCO₂eq"} per kg
        </p>
        <div className="tw-mt-2 tw-bg-secondary/50 tw-rounded-md tw-p-3.5 tw-text-[11px] tw-text-muted-foreground tw-leading-relaxed">
          {COMPANY_NAME} {ImpactAssessmentMethodText}
        </div>
      </CardContent>
    </Card>
  );
};
